import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { DamageDetectionDto } from "@/core/api/generated/v1";

import EntityInboxList from "../../../Chat/ListView/EntityInboxList";

interface Props {
  damageDetection: DamageDetectionDto;
}

export default function InboxTabContent({ damageDetection }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={1} sx={{ p: 0, borderRadius: "inherit" }}>
        <EntityInboxList
          displayProps={{
            header: false,
            viewVariant: ViewVariant.Tab,
          }}
          defaultValues={{
            damageDetectionId: damageDetection.id!,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
